// extracted by mini-css-extract-plugin
module.exports = {"checklist":"Checklist_checklist__1yz99","add":"Checklist_add__2x4fv"};